import Swal from "sweetalert2";

export const fireSwal = (title: string, text: string) => {
  Swal.fire({
    position: "top",
    target: document.getElementById("embed-container"),
    heightAuto: false,
    allowOutsideClick: false,
    icon: "error",
    iconHtml: `<span class="text-red-500"><svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="h-8 w-8 md:w-12 md:h-12">
  <path stroke-linecap="round" stroke-linejoin="round" d="M12 9v3.75m9-.75a9 9 0 1 1-18 0 9 9 0 0 1 18 0Zm-9 3.75h.008v.008H12v-.008Z" />
</svg></span>
`,
    title,
    text,
    customClass: {
      popup: "mt-8 w-fit",
      icon: "text-base text-red-500 mt-4 mb-0 p-0 mx-auto h-12 w-12 border-0",
      title: "text-xl md:text-3xl p-0 text-red-500 ",
    },
  });
};
